<template>
  <div>
    <HeaderShipmentType :dataHeader="currentDataHeader('AIRCARGO')" />
    <div class="shipmentair__tabs--contain">
      <p class="fontstyle__default--blue mb-2">Enter Your Shipment Data</p>
        <ShipmentData
            @setType='setType'
            @calcTotalShipment='calcTotalShipment'
            @checkError='checkErrorLCL'
            :optionQtyUnit="optionQtyUnit"
            :item="loadsForm" />
        <div v-if="this.error.errorsLCL" class="fontstyle__errormsg">
          Required
        </div>
    </div>
  </div>
</template>

<script>
import { UNIT_COMMODITY_QUANTITY } from '@/constant/options_list'
import HeaderShipmentType from '@/components/contract/components/HeaderShipmentType'
import ShipmentData from '@/components/contract/components/ShipmentData'

export default {
  name: 'lcl',
  props: {
    showErrorLCL: Boolean
  },
  components: {
    HeaderShipmentType,
    ShipmentData
  },
  data () {
    return {
      tabIndex: 0,
      optionQtyUnit: UNIT_COMMODITY_QUANTITY,
      type: 'Ocean',
      units: 'Packages',
      data: {
        satuan: 'Packages',
        shipment_type: 'SEALCL',
        service_head: 'OCEAN',
        estimateddimention: 0,
        totalshipment: '',
        total_weight: '',
        total_quantity: '',
        lengthdimension: 0,
        widthdimension: 0,
        heightdimension: 0,
        totalWeightPerShipment: 0
      },
      loadsForm: {
        totalshipment: null,
        total_quantity: null,
        total_weight: null,
        satuan: 'Packages',
        size: {
          length: '',
          width: '',
          height: ''
        },
        totalWeightPerShipment: 0
      },
      totalWeight: 0,
      totalShipment: 0,
      error: {}
    }
  },
  mounted () {
  },
  methods: {
    currentDataHeader () {
      let data = {}
      data = {
        shipmenttype: 'LCL',
        img: require('@/assets/image/icon/icon-ocean-lcl.svg'),
        text: 'Get the best rates for your shipment to all around the world with LCL services.',
        InfoShipment: [
          { title: 'Estimate Weight/Shipment', value: `${this.loadsForm.totalWeightPerShipment.toFixed(2)} Kg` }
        ]
      }
      return data
    },

    calcVM (item) {
      const size = item.size
      const cbm = 1000000
      const volume = parseInt(size.length) * parseInt(size.width) * parseInt(size.height)
      let totalCBM = (volume / cbm) * item.total_quantity
     
      return !isNaN(totalCBM) ? totalCBM > 2.000 ? totalCBM : 2.000 : 0
    },

    calcTotalShipment () {
      const ojct = this.loadsForm
      let tempTotal = 0
      let total = 0 
      if (ojct.total_weight && ojct.totalshipment && ojct.total_quantity) {
        tempTotal = ojct.total_weight * ojct.total_quantity
        total = Math.ceil(tempTotal) / parseInt(ojct.totalshipment)
      }
      this.loadsForm.totalWeightPerShipment = total
      this.checkErrorLCL()
      this.pushData()
    },

    pushData () {
      const dataForm = this.loadsForm
      const dataFormSize = this.loadsForm.size
      this.data.estimateddimention = this.calcVM(dataForm)
      this.data.totalshipment = parseFloat(dataForm.totalshipment)
      this.data.total_weight = parseFloat(dataForm.total_weight)
      this.data.total_quantity = parseFloat(dataForm.total_quantity)
      this.data.lengthdimension = parseFloat(dataFormSize.length)
      this.data.widthdimension = parseFloat(dataFormSize.width)
      this.data.heightdimension = parseFloat(dataFormSize.height)
      this.data.totalWeightPerShipment = dataForm.totalWeightPerShipment
      this.$emit('inputData', this.data)
    },

    setType (item) {
      this.loadsForm.satuan = item.type
    },

    checkErrorLCL () {
      const data = this.loadsForm
      const dataSize = this.loadsForm.size
      if (!data.totalshipment || !data.total_quantity || !data.total_weight || 
          !dataSize.height || !dataSize.width || !dataSize.length) {
        this.error = {
          errorsLCL: true
        }
      } else {
        this.error = {
          errorsLCL: false
        }
      }
      this.$emit('errorInputLCL', this.error)
    }
  },
  computed: {
  },
  watch: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contract/ShipmentType/LCL.vue